import request from "@/modules/request";

export default class CompanyService {
  constructor() {}

  async resendUserInvite(userId) {
    return request
      .callInternal({
        method: "post",
        route: `/api/admin/resenduserinvite`,
        data: {
          userId,
        },
      })
      .then((results) => {
        return results;
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }

  async associateUpdateCompany(companyId, data) {
    return request
      .callInternal({
        method: "patch",
        route: `/api/admin/company/${companyId}`,
        data,
      })
      .then((results) => {
        return results;
      })
      .catch((error) => {
        console.error(`Error updating company: `, error);
        throw error;
      });
  }

  async userUpdateCompany(companyId, data) {
    return request
      .callInternal({
        method: "patch",
        route: `/api/company/${companyId}`,
        data,
      })
      .then((results) => {
        return results;
      })
      .catch((error) => {
        console.error(`Error updating company: `, error);
        throw error;
      });
  }
}
